import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import styles from "./notification.module.css";

const Notification = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Set active state based on the current route
  const [activeHeads, setActiveHeads] = useState(location.pathname === '/notification/matches' ? "matches" : location.pathname === '/notification/all' ? "all" : "requests");

  const handleHeadClick = (value) => {
    setActiveHeads(value);
    if (value === "all") {
      navigate("/notification/all");  // Navigate to /notification/all
    } else if (value === "matches") {
      navigate("/notification/matches");  // Navigate to /notification/matches
    }
    else {
      navigate("/notification/requests");
    }
  };


  return (
    <div className={styles.mainContent}>
      <div className={styles.notificationHeader}>
        <h2 className={styles.notificationHeading}>Notification</h2>
      </div>

      {/* Notification Toggle Buttons */}
      <div className={styles.notificationToggle}>
        <button
          className={activeHeads === "all" ? styles.activeToggle : styles.inactiveToggle}
          onClick={() => handleHeadClick("all")}
        >
          All
        </button>
        <button
          className={activeHeads === "matches" ? styles.activeToggle : styles.inactiveToggle}
          onClick={() => handleHeadClick("matches")}
        >
          Matches
        </button>
        <button
          className={activeHeads === "requests" ? styles.activeToggle : styles.inactiveToggle}
          onClick={() => handleHeadClick("requests")}
        >
          Requests
        </button>
      </div>

      {/* Notification Content */}
      <div className={styles.notificationWrapper}>
        {/* Render the nested routes (either AllNotifications or MatchNotifications) */}
        <Outlet />
      </div>
    </div>
  );
};

export default Notification;
